import React from 'react';
import { Flex } from '@procore/core-react';
import { Typography } from '@mui/material';
import { useStyles } from './DescriptionWithIconAndTitle.styles';

interface DescriptionWithIconAndTitleProps {
  icon: React.ReactNode;
  textComponent: React.ReactNode;
  descriptionWithIconStyle?: string;
  title?: string;
}

const DescriptionWithIconAndTitle = ({
  icon,
  textComponent,
  descriptionWithIconStyle,
  title,
}: DescriptionWithIconAndTitleProps) => {
  const classes = useStyles();

  return (
    <Flex
      justifyContent="flex-start"
      alignItems="flex-start"
      className={`${classes.containter} ${descriptionWithIconStyle || ''}`}
      gap="10px"
    >
      <div className={classes.icon}>{icon}</div>
      <div className={classes.content}>
        {title && <Typography variant="smallTitle">{title}</Typography>}
        {textComponent}
      </div>
    </Flex>
  );
};

export default DescriptionWithIconAndTitle;
